import React, { FunctionComponent } from "react"
import ArtPieceItem from "./Item"
import ArtPieceFilters from "./Filters"
import Seo from "../../components/Seo/Seo"
import Grid from "../../components/Grid/Grid"
import Loader from "../../components/Loader/Loader"
import Pagination from "../../components/Pagination/Pagination"
import { iArtPiece, iArtPieceQuery } from "../../definitions/ArtPieces"
import { useData } from "../../hooks/useData"
import LinkItem from "../../components/Grid/LinkItem"

import s from "./ArtPieces.less"

const ArtPieces: FunctionComponent = () => {
  const { total, data, loading, setQuery, query } = useData<
    iArtPieceQuery,
    iArtPiece
  >({
    link: "/v1/art-pieces",
    defaultQuery: {},
    shouldPushQuery: true,
  })

  return (
    <>
      <Seo title={"Art Pieces"} />
      <div className="content">
        <div className="content-header">
          <h1>Art pieces ({total})</h1>
          <ArtPieceFilters setQuery={setQuery} query={query} />
        </div>
        <div className={`grid-wrap ${s.gridWrap}`}>
          {loading ? (
            <Loader />
          ) : data.length ? (
            <Grid>
              {data.map((art) => (
                <LinkItem key={art._id} url={"/art-pieces/" + art.shrUrl}>
                  <ArtPieceItem
                    key={art._id}
                    {...art}
                    // openInspector={openInspector}
                  />
                </LinkItem>
              ))}
            </Grid>
          ) : (
            <div className="no-data">No matching results.</div>
          )}
        </div>
        <Pagination total={total} setQuery={setQuery} limit={50} />
      </div>
    </>
  )
}

export default ArtPieces
